var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"bottom","trigger":"hover","popper-class":"member-popover"}},[_c('div',{staticClass:"common-introduce"},[_vm._t("tips")],2),_c('span',{staticClass:"iconfont icon-doubt",attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }